import { rendererTypeName } from '@angular/compiler'
import {Encrypt64 } from './encrypt64'

export class Twofish {
  constructor () {
  }

  public static encrypt64 (value: string, key: string): string{
    return Encrypt64.encrypt64(value, key);
  }
}
